module.exports = __webpack_public_path__ + "static/people_img11-f0c2c53b02db5663481776f10018f8b1.png";